﻿import { createVirtualURL, getActiveFilters } from "../../components/category";
import { sendDataLayer } from "../../components/ecommerce/ecommerce";
import { refreshKeyboardInteractions } from "../../helpers";
import { filterOptionResponse } from "../../models/category/filterOptionResponse";
import { getTranslations } from "../../translations";
import { sendApiCall } from "../../utilities/api";
import { renderTemplate } from "../../utilities/cms.TemplateEngine";
import { Popup, PopupButton, PopupPosition } from "../../utilities/popup";
import { getTemplate } from "../../utilities/templates";
import { loadTrackablePage } from "./filter";

export class FilterExplanation
{
    popup: Popup;
    title: string;
    subTitle: string;

    // Store previous filter explanation search url/result.
    prevFilterExplanationSearch = [];
    filterModalOpen: boolean;
    filterModalTimeout;
    filterPopupDoubleClick;
    buildFilterUrl: string = "";
    propertyIDs: Array<number> = [];
    filterInfoCall;
    filterResultCount: number;

    filterExplanationPopupHtml = getTemplate("filter.explanation.popup.html");
    filterExplanationPopupOptionImageHtml = getTemplate("filter.explanation.option.image.html");
    filterExplanationPopupOptionHtml = getTemplate("filter.explanation.option.html");

    constructor()
    {
        this.findFilterExplanationForPage();
    }

    private findFilterExplanationForPage = () =>
    {
        const instance = this;
        if ($('.j-filter').length > 0)
        {
            var foundStored = false;
            var foundPrevItem = null;
            var path = document.location.pathname;

            $(".j-filter__list-item").each(function ()
            {
                const propertyID = $(this).data("property-id");
                if (!instance.propertyIDs.includes(propertyID))
                    instance.propertyIDs.push(propertyID);
            });

            // Check if previous search was with same URL. If yes, use that result instead of retrieving it again.
            if (this.prevFilterExplanationSearch.length > 0)
            {
                foundPrevItem = this.prevFilterExplanationSearch.find(x => x.path === path);

                if (typeof (foundPrevItem) !== typeof (undefined) &&
                    foundPrevItem != null
                )
                    foundStored = true;
            }

            // Found stores result for the given path. Use it instead of retrieving new filter explanations.
            if (foundStored)
                this.handleFilterExplanationForPageResult(foundPrevItem["path"], foundPrevItem["result"], true);
            // No previous result was found or the search url changed; retrieve new filter explanations.
            else
            {
                var callback = function (data, statusText, jqXHR)
                {
                    var result;

                    if (data.d !== undefined)
                        result = JSON.parse(data.d);
                    else if (data !== undefined)
                        result = data;

                    instance.handleFilterExplanationForPageResult(path, result, false);
                };

                if (shopConfig().api.active)
                    sendApiCall({ endpoint: '/Filter/GetExplanationForPage', shopMode: 'Search', rawUrl: location.pathname, qsDictionary: [{ 'url': path }], callback: callback });
                else
                {
                    $.ajax({
                        type: "POST",
                        url: "/Services/Modules/Webshop.asmx/GetFilterExplanation?url=" + path,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        success: callback
                    });
                }
            }
        }
    }

    private handleFilterExplanationForPageResult = (path, result: Array<filterOptionResponse>, fromStored) =>
    {
        const instance = this;
        if (result && result.length > 0)
        {
            // Retrieve only availableFilters
            const availableFilters = getActiveFilters(false, false, false, true);
            result.forEach((item: filterOptionResponse, index) =>
            {
                try
                {
                    var propertyID = item.propertyID;
                    var explanationID = item.explanationID;
                    var availableOptionsInPopup: Array<number> = item.explanationOptionIDs;
                    var rangeFilter = item.isRangeProperty;
                    var showExplanationPopupButton = false;
                    var availableOptions: Array<number> = new Array();

                    // Determine what property options are present on the page for the current property
                    if (typeof availableFilters !== typeof (undefined) && availableFilters != null && availableFilters.length > 0)
                    {
                        $(availableFilters).each(function (index, value)
                        {
                            if (availableFilters[index][0] == propertyID)
                                availableOptions.push(parseInt(availableFilters[index][1]));
                        });
                    }

                    if (!rangeFilter &&
                        (
                            typeof (availableOptionsInPopup) != typeof (undefined) &&
                            availableOptionsInPopup != null &&
                            availableOptionsInPopup.length > 0 &&
                            availableOptions.length > 0
                        )
                    )
                    {
                        // Don't show the popup unless we have at least one available option to show
                        showExplanationPopupButton = availableOptionsInPopup.some(
                            (opt: number) => availableOptions.includes(opt)
                        );
                    }
                    else
                        showExplanationPopupButton = true;

                    if (showExplanationPopupButton)
                    {
                        var explanationPopupButton = document.createElement("button");
                        explanationPopupButton.title = getTranslations().explanationText; // Use text from language file.
                        $(explanationPopupButton).addClass("c-filter-explanation");
                        $(explanationPopupButton).addClass("js-filter-explanation-icon");
                        $(explanationPopupButton).addClass("ic-info");
                        $(explanationPopupButton).addClass("btn-none");
                        $(explanationPopupButton).data('explanationID', explanationID);
                        $(explanationPopupButton).data('propertyID', propertyID);

                        var filters = $(".j-filter__list-item[data-property-id=" + propertyID + "]");
                        if (filters.length > 0)
                        {
                            // remove old ones if present
                            $(filters).find(".c-filter-explanation").remove();

                            $(filters).find(".w-filter__title").append(explanationPopupButton);
                            $(filters).find(".c-filter-explanation").fadeIn();
                        }
                    }
                    else
                    {
                        var filters = $(".j-filter__list-item[data-property-id=" + propertyID + "]");

                        if (filters.length > 0)
                            // remove old ones if present
                            $(filters).find(".c-filter-explanation").remove();
                    }
                }
                catch (err)
                {
                    console.error(err);
                }
            });

            $(".j-filter__list-item .c-filter-explanation").off();
            $(".j-filter__list-item .c-filter-explanation").on("click", function ()
            {
                instance.loadFilterExplanation($(this), $(this).data("propertyID"));
            });

        }

        // When value was retrieved again, not taken out of prevFilterExplanationSearch, store it.
        if (!fromStored)
            instance.prevFilterExplanationSearch.push({ "path": path, "result": result });
    }

    private loadFilterExplanation = (element, propertyID) =>
    {
        const instance = this;
        if (this.filterModalOpen)
            return;

        var property = $(".j-filter__list-item[data-property-id=" + propertyID + "] .w-filter__title").text();

        sendDataLayer({
            'category': 'productlist',
            'action': 'Maatuitleg',
            'label': property,
            'url': createVirtualURL(),
            'event': 'filterClick'
        });

        var explanationID = $(element).data('explanationID');

        // Retrieve the wizard information
        var resetUIblock = true;

        var callback = function (data, statusText, jqXHR)
        {
            var result = '';
            if (typeof (data.d) !== typeof (undefined))
                result = data.d;
            else if (typeof (data) !== typeof (undefined))
            {
                result = data;
                var renderedOptions = '';
                var popupTE = [];

                if (typeof (data.options) !== typeof (undefined) &&
                    data.options != null)
                {
                    data.options.forEach(function (item, index)
                    {
                        var template;
                        var optionTE = [];
                        if (item.image !== undefined && item.image != null)
                        {
                            template = instance.filterExplanationPopupOptionImageHtml;
                            optionTE.push({ "image": item.image });
                        }
                        else
                            template = instance.filterExplanationPopupOptionHtml;

                        optionTE.push({ "title": item.title });
                        optionTE.push({ "description": item.description });
                        optionTE.push({ "optionID": item.searchNameID });

                        renderedOptions += renderTemplate(optionTE, template);
                    });
                }

                popupTE.push({ "options": renderedOptions });

                instance.title = data.title;
                instance.subTitle = data.description;
                popupTE.push({ "title": data.title });
                popupTE.push({ "description": data.description });
                popupTE.push({ "propertyID": data.propertyID });
                popupTE.push({ "wizardID": data.wizardID });

                result = renderTemplate(popupTE, instance.filterExplanationPopupHtml);
            }

            resetUIblock = false;
            this.buildFilterUrl = '';

            const buttonList = [];
            const btnShow = new PopupButton();
            btnShow.className = "btn btn-green show-results full-width";
            btnShow.label = getTranslations().filterShowresultText;
            buttonList.push(btnShow);

            const closeButton = new PopupButton();
            closeButton.closeOnCLick = true;
            closeButton.onClick = () =>
            {
                instance.popup.destroy();
            };

            instance.popup = new Popup({
                id: "explanation-modal",
                buttons: buttonList,
                title: instance.title,
                subtitle: instance.subTitle,
                closeButton: closeButton,
                content: result,
                mobilePosition: PopupPosition.fullScreen,
                onHide: () =>
                {
                    instance.popup.destroy();
                },
                popupClass: "g-popup__container--w-480"
            }).show();

            // attach events
            instance.addExplanationEvents();
            refreshKeyboardInteractions();
        };

        if (shopConfig().api.active)
        {
            sendApiCall({ endpoint: '/Filter/GetFilterExplanation', shopMode: 'Search', rawUrl: location.pathname, qsDictionary: [{ 'explanationID': explanationID }], callback: callback });
        }
        else
        {
            $.ajax({
                type: "POST",
                url: "/Services/Modules/Webshop.asmx/GetFilterExplanation?explanationID=" + explanationID,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: callback
            });
        }
    }

    private addExplanationEvents = () =>
    {
        const instance = this;
        // check for all ready selected options
        $(".c-explanation-popup__option, .c-explanation-popup__option--image").each(function (index, item)
        {
            var option = $(item);
            var propertyID = $(option).data("property");
            var optionID = $(option).data("option");

            var checkbox = $("[data-id=chk-" + propertyID + "-" + optionID + "]");

            var isDisabled = $("[data-id=chk-" + propertyID + "-" + optionID + "]").closest(".row").data("disabled");

            if (typeof (isDisabled) === typeof (undefined) ||
                isDisabled == null
            )
                isDisabled = false;

            // Disable explanation popup item if its filter does not exist or is disabled.
            if (checkbox && checkbox.length > 0 && !isDisabled)
            {
                if (checkbox.prop("checked"))
                    instance.toggleExplanationOption(option, propertyID, optionID, true);
            }
            else
                $(option).addClass("disabled");
        });

        if ($("#modal-explanation-modal .c-explanation-popup__option--image") && $("#modal-explanation-modal .c-explanation-popup__option--image").length > 0)
        {
            $("#modal-explanation-modal .c-explanation-popup__option--image").off();
            $("#modal-explanation-modal .c-explanation-popup__option--image").on("click", function ()
            {
                instance.handleExplanationClick($(this));
            });
        } else if ($("#modal-explanation-modal .c-explanation-popup__option") && $("#modal-explanation-modal .c-explanation-popup__option").length > 0)
        {

            $("#modal-explanation-modal .c-explanation-popup__option").off();
            $("#modal-explanation-modal .c-explanation-popup__option").on("click", function ()
            {
                instance.handleExplanationClick($(this));
            });
        }

        if ($("#modal-explanation-modal .show-results") && $("#modal-explanation-modal .show-results").length > 0)
        {
            $("#modal-explanation-modal .show-results").off();
            $("#modal-explanation-modal .show-results").on("click", function ()
            {
                $("#modal-explanation-modal button").off("click");
                instance.applyExplanationFilters();
                instance.closeFilterExplanation();
            });
        }
    }

    private closeFilterExplanation = () =>
    {
        this.popup.hide();
        this.popup.destroy();
    }

    private handleExplanationClick = (option) =>
    {
        const instance = this;
        if ($(option).hasClass("disabled"))
            return;

        if (this.filterPopupDoubleClick)
        {
            this.filterPopupDoubleClick = false;
            clearTimeout(instance.filterModalTimeout);

            // make sure it is selected
            if (!$(option).hasClass("selected"))
            {
                var propertyID = $(option).data("property");
                var optionID = $(option).data("option");

                this.toggleExplanationOption(option, propertyID, optionID, false);
            }

            $("#modal-explanation-modal button").off("click");

            this.selectExplanationFilters();
            this.applyExplanationFilters();
            this.closeFilterExplanation();
        }
        else
        {
            this.filterPopupDoubleClick = true;

            var propertyID = $(option).data("property");
            var optionID = $(option).data("option");

            this.toggleExplanationOption(option, propertyID, optionID, false);

            this.filterModalTimeout = setTimeout(function ()
            {
                instance.filterPopupDoubleClick = false;
            }, 250);
        }
    }

    private toggleExplanationOption = (option, propertyID, optionID, onlyVisual) =>
    {
        var selected = $(option).hasClass("selected");

        if (selected)
        {
            $(option).removeClass("selected");
            $(option).find("[type=checkbox]").prop("checked", false);
        }
        else
        {
            $(option).addClass("selected");
            $(option).find("[type=checkbox]").prop("checked", true);
        }

        this.selectExplanationFilters();
    }

    private selectExplanationFilters = () =>
    {
        const instance = this;
        var trackableFound = false;
        var trackableOverrideFound = false;
        var noOptions = true;
        var callQueryString = '';
        var trackableUrl = '';
        var currentHash = '';

        if (this.buildFilterUrl?.length == 0)
            this.buildFilterUrl = document.location.pathname + document.location.hash;

        if (this.buildFilterUrl?.length > 0)
        {
            var parts = this.buildFilterUrl.split('#');

            if (parts.length > 1)
                currentHash = parts[1];
        }

        var currentOptions = new Array();
        var trackableOptions = new Array();

        if (currentHash.length > 1)
        {
            if (currentHash.indexOf('#') == 0)
                currentHash = currentHash.substring(1);

            var propertiesSplit = currentHash.split('_');

            for (var i = 0; i < propertiesSplit.length; i++)
            {
                var optionSplit = propertiesSplit[i].split('-');
                var optionArray = new Array();
                var property = optionSplit[0];

                if (currentOptions[property] === undefined)
                    currentOptions[property] = new Array();

                optionArray = currentOptions[property];
                optionArray.push(optionSplit[1]);

                currentOptions[property] = optionArray;
            }
        }

        //reset the currentHash
        var newHash = '';
        var propertyID = 0;
        var newOptions = new Array();

        $(".explanation-option, .c-explanation-popup__option--image, .c-explanation-popup__option--color").each(function ()
        {
            var option = $(this);
            var selected = $(option).hasClass("selected");

            propertyID = $(option).data("property");
            var optionID = $(option).data("option");

            if (selected)
            {
                newOptions.push(optionID);
                noOptions = false;
            }
        });

        // override the current property
        currentOptions[propertyID] = newOptions;

        // check what filter options are available in popup
        var popupEnabledFilterOptions = new Array();

        $(".c-explanation-popup__content .c-explanation-popup-content__options > div").each(function (index, item)
        {
            var optionID = parseInt($(item).data("option"));
            var propertyID = parseInt($(item).data("property"));

            if (!isNaN(optionID) && !isNaN(propertyID))
                popupEnabledFilterOptions[optionID] = propertyID;
        });

        // check if a trackable option was active before
        $(".j-filter__list-item input[type=checkbox]:checked").each(function (index, item)
        {
            var optionID = parseInt($(item).val() as string ?? "0");
            var propertyID = parseInt($(item).closest(".j-filter__list-item").data("property-id"));

            // Only check filters that are also available in the popup
            if (popupEnabledFilterOptions[optionID] == propertyID)
            {
                var updateTrackable = false;

                if (currentOptions[propertyID] !== undefined)
                {
                    if (!currentOptions[propertyID].includes(optionID))
                        updateTrackable = true;
                }
                else
                    updateTrackable = true;

                // selected filter is not present we need to remove it from our base url.
                var filter = $("[data-id=chk-" + propertyID + "-" + optionID + "]");

                if (filter && filter.length > 0)
                {
                    var link = $(filter).parent().find("a");
                    var tmpUrl = '';

                    if (link && link.length > 0)
                    {
                        tmpUrl = link.attr("href");
                        var foundTrackable = '';

                        if (tmpUrl.length > 1 && tmpUrl != '#')
                        {
                            if (trackableUrl.length < tmpUrl.length)
                                trackableUrl = tmpUrl;
                        }

                        if (tmpUrl.length > 1 && tmpUrl.indexOf('#') <= -1)
                            foundTrackable = tmpUrl;
                        else if (tmpUrl.length > 1 && tmpUrl != '#')
                        {
                            // remove the hash if present
                            if (tmpUrl.indexOf('#') > 0)
                                foundTrackable = tmpUrl.split('#')[0];
                            else
                                foundTrackable = tmpUrl;
                        }

                        if (foundTrackable.length > 0)
                        {
                            var currentPath = document.location.pathname;
                            var trackablePart = currentPath.replace(foundTrackable, '');

                            var optionUrl = foundTrackable + trackablePart;
                            trackableOptions[optionID] = optionUrl;

                            if (updateTrackable)
                                trackableUrl = foundTrackable;
                        }
                    }
                    // Only update trackableUrl if new url is shorter
                    else if (trackableUrl.length <= 0 || trackableUrl.length > document.location.pathname.length)
                        trackableUrl = document.location.pathname;
                }
            }
        });

        for (var index = 0; index < instance.propertyIDs.length; index++)
        {
            var propertyID = instance.propertyIDs[index];

            if (currentOptions[propertyID] != null && currentOptions[propertyID].length > 0)
            {
                var value = currentOptions[propertyID];

                for (var i = 0; i < value.length; i++)
                {
                    var optionID = value[i];
                    var isTrackableOption = false;

                    if (!trackableFound)
                    {
                        // check for url
                        var filter = $("[data-id=chk-" + propertyID + "-" + optionID + "]");

                        if (filter && filter.length > 0)
                        {
                            var link = $(filter).parent().find("a");
                            var tmpUrl = '';

                            if (link && link.length > 0)
                            {
                                if (!filter.prop("checked"))
                                    tmpUrl = link.attr("href");

                                if (tmpUrl.length > 1 && tmpUrl != '#')
                                {
                                    if (trackableUrl.length < tmpUrl.length)
                                        trackableUrl = tmpUrl;
                                    isTrackableOption = true;
                                    trackableFound = true;
                                }
                                else if (!trackableOverrideFound && trackableOptions[optionID] !== undefined)
                                {
                                    if (trackableUrl.length < trackableOptions[optionID].length)
                                        trackableUrl = trackableOptions[optionID];

                                    isTrackableOption = true;
                                    trackableOverrideFound = true;
                                    trackableFound = true;
                                }
                            }
                        }
                    }
                    else if (!trackableOverrideFound && trackableOptions[optionID] !== undefined)
                    {
                        if (trackableUrl.length < trackableOptions[optionID].length)
                            trackableUrl = trackableOptions[optionID];

                        isTrackableOption = true;
                        trackableOverrideFound = true;
                    }

                    if (!isTrackableOption)
                    {
                        var newOption = propertyID + "-" + optionID;

                        if (newHash.length == 0)
                            newHash = "#" + newOption;
                        else
                            newHash += "_" + newOption;

                        callQueryString += '&property_' + propertyID + '=' + optionID;
                    }
                }
            }
        }

        instance.buildFilterUrl = trackableUrl + newHash;

        if (noOptions)
        {
            var resultText = String.format(getTranslations().filterResultText, '');
            $(".show-results").text(resultText);
        }
        else
        {
            if (instance.filterInfoCall != null)
                instance.filterInfoCall.abort();

            var searchUrl = instance.buildFilterUrl;

            if (searchUrl.length == 0 || searchUrl.startsWith('#'))
                searchUrl = document.location.pathname;
            else if (searchUrl.indexOf('#') > -1)
            {
                var parts = searchUrl.split('#');
                searchUrl = parts[0];
            }

            var priceFilters = getActiveFilters(false, false, true, false);

            if (typeof priceFilters !== typeof (undefined) && priceFilters != null && priceFilters.length > 0)
            {
                $(priceFilters).each(function (index, value)
                {
                    var priceFilterItem = priceFilters[index][0];
                    var priceFilterValue = priceFilters[index][1];

                    callQueryString += "&" + priceFilterItem + "=" + priceFilterValue;
                });
            }

            var url = "/Services/Modules/Webshop.asmx/GetFilterResultCount?url=" + searchUrl + callQueryString;

            this.filterInfoCall = $.ajax({
                type: "POST",
                url: url,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (data, statusText, jqXHR)
                {
                    instance.filterResultCount = parseInt(data.d);
                    var resultText = String.format(getTranslations().filterResultText, instance.filterResultCount);
                    $("#modal-explanation-modal .show-results").text(resultText);
                }
            });
        }
    }

    private applyExplanationFilters = () =>
    {
        var currentPath = document.location.pathname + document.location.hash;

        if (this.buildFilterUrl.length > 0 && this.buildFilterUrl != currentPath)
        {
            var parts = this.buildFilterUrl.split('#');
            var currentHash = '';

            if (parts.length > 1)
                currentHash = parts[1];

            if (parts[0].length > 0)
            {
                if (currentHash.length > 1)
                {
                    loadTrackablePage(
                        this.buildFilterUrl,
                        false
                    );
                }
                else
                {
                    loadTrackablePage(
                        parts[0],
                        false
                    );
                }
            }

            if (currentHash.length > 1)
            {
                setTimeout(function ()
                {
                    document.location.hash = currentHash;
                }, 50);
            }
        }
    }
}